import { forwardRef, memo } from "react";
import classnames from "classnames";
import { GrayEmpty } from "../icons";
import { FileTypeBase } from "../types";
import { getExtension, getMimeTypeInfo } from "../utils";

import styles from "./style.module.scss"

type FileGrayProps = FileTypeBase

export const FileGray= memo(forwardRef<HTMLDivElement, FileGrayProps>((
  {
    isFolder = false,
    mimeType,
    className,
    fileExtension,
    videoIconType = "video01",
    ...props
  },
  ref
) => {
  const fileExt = getExtension(fileExtension);

  const { icon, type } = getMimeTypeInfo(mimeType, isFolder, videoIconType);

  return (
    <div
      className={classnames(className, styles.root)}
      ref={ref}
      {...props}
    >
      <GrayEmpty />
      {fileExt ? (
        <span className={classnames(styles.name)}>
          {fileExt}
        </span>
      ) : <i className={classnames(
        styles.iconMimeWrapper,
        styles[type as keyof typeof styles]
      )}>{icon}</i>}
    </div>
  )
}));